export const MAX_QUANTITY_PRODUCT = Number(
  process.env.NEXT_PUBLIC_MAX_QUANTITY_PRODUCT ?? 5
)
